import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, MessageSquareText } from "lucide-react";
import { api } from "@/lib/api";
import { HEAD, Pill } from "@/components/PdPill";
import { StatusBar } from "@/components/sms/StatusBar";
import { PhoneCard } from "@/components/sms/PhoneCard";
import { ScanProgress } from "@/components/sms/ScanDialog";
import { CodesTab } from "@/components/sms/CodesTab";
import { MessagesTab } from "@/components/sms/MessagesTab";

export default function SmsInbox() {
  const navigate = useNavigate();
  const [status, setStatus] = useState(null);
  const [tab, setTab] = useState("codes");
  const [tick, setTick] = useState(0);
  const loadStatus = useCallback(() => {
    api.get("/sms/status").then(({ data }) => setStatus(data)).catch(() => {});
  }, []);
  useEffect(() => {
    loadStatus();
    const t = setInterval(() => { loadStatus(); setTick((n) => n + 1); }, 4000);
    return () => clearInterval(t);
  }, [loadStatus]);

  return (
    <div className="min-h-screen bg-[#F4F3EC]" data-testid="sms-inbox-page">
      <header className="bg-[#385C4B] text-white sticky top-0 z-30 shadow-[0_6px_20px_rgba(56,92,75,0.2)]">
        <div className="max-w-6xl mx-auto px-3 sm:px-6 h-14 flex items-center gap-2.5">
          <button onClick={() => navigate("/home")} className="grid place-items-center w-9 h-9 rounded-full hover:bg-white/10 transition-colors" data-testid="sms-back" aria-label="Back">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <MessageSquareText className="w-5 h-5" />
          <h1 className={`${HEAD} text-lg sm:text-xl font-semibold whitespace-nowrap`}>
            <span className="hidden sm:inline">Messages · </span>SMS Inbox
          </h1>
          <span className="text-[10px] font-mono uppercase bg-white/15 px-2 py-0.5 rounded-full">Admin</span>
          <span className="ml-auto hidden sm:inline text-xs tabular-nums" data-testid="sms-header-counts">
            {status?.counts ? `${status.counts.today} today · ${status.counts.new} new` : ""}
          </span>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-3 sm:px-6 py-6 space-y-4">
        <div className="grid lg:grid-cols-2 gap-4 items-start">
          <PhoneCard status={status} onChanged={loadStatus} />
          <StatusBar status={status} onChanged={loadStatus} />
        </div>
        <ScanProgress scan={status?.scan} onStop={() => api.post("/sms/scan/stop").then(loadStatus).catch(() => {})} />
        <div className="flex gap-2">
          <Pill on={tab === "codes"} onClick={() => setTab("codes")} testid="sms-tab-codes">Codes</Pill>
          <Pill on={tab === "messages"} onClick={() => setTab("messages")} testid="sms-tab-messages">Messages</Pill>
        </div>
        {tab === "codes" ? <CodesTab counts={status?.counts} tick={tick} onChanged={loadStatus} /> : <MessagesTab tick={tick} />}
      </main>
    </div>
  );
}
